import React, { useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import API_URL from "../apiConfig";

export default function HeadwiseReport({ token }) {
  const [type, setType] = useState("income");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchReport = async () => {
    setLoading(true);
    setError("");
    let url = `${API_URL}/api/income_expense/report/headwise?type=${type}`;
    if (from && to) url += `&from=${from}&to=${to}`;
    try {
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to fetch report");
      const body = await res.json();
      setData(body);
    } catch (err) {
      setError(err.message);
      setData([]);
    }
    setLoading(false);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(16);
    doc.text(
      `${type === "income" ? "Income" : "Expense"} Headwise Report`,
      105,
      15,
      { align: "center" }
    );

    if (from || to) {
      doc.setFontSize(11);
      doc.text(
        `Period: ${from ? new Date(from).toLocaleDateString() : ""} - ${to ? new Date(to).toLocaleDateString() : ""}`,
        105,
        23,
        { align: "center" }
      );
    }

    // Prepare table data
    const tableHead = [
      ["Sr No", type === "income" ? "Income Head" : "Expense Head", "Amount"],
    ];
    const tableBody = data.map((row, idx) => [
      idx + 1,
      row.account_head,
      Number(row.total).toLocaleString("en-IN", { minimumFractionDigits: 2 }),
    ]);
    // Add total row
    tableBody.push([
      { content: "Total", colSpan: 2, styles: { fontStyle: "bold" } },
      {
        content: data
          .reduce((sum, row) => sum + (Number(row.total) || 0), 0)
          .toLocaleString("en-IN", { minimumFractionDigits: 2 }),
        styles: { fontStyle: "bold" },
      },
    ]);

    autoTable(doc, {
      head: tableHead,
      body: tableBody,
      startY: 30,
      styles: { font: "helvetica", fontSize: 10 },
      theme: "grid",
      headStyles: { fillColor: [41, 128, 185] },
      footStyles: { fontStyle: "bold" },
      columnStyles: {
        0: { cellWidth: 20, halign: "center" },
        1: { cellWidth: 80 },
        2: { cellWidth: 35, halign: "right" },
      },
    });

    doc.save(`${type === "income" ? "Income" : "Expense"}_Headwise_Report.pdf`);
  };

  const totalAmount = data.reduce((sum, row) => sum + (Number(row.total) || 0), 0);

  return (
    <div className="reports-section">
      <h3>{type === "income" ? "Income" : "Expense"} Headwise Report</h3>
      <div style={{ marginBottom: 12 }}>
        <select value={type} onChange={e => setType(e.target.value)}>
          <option value="income">Income</option>
          <option value="expense">Expense</option>
        </select>
        <input
          type="date"
          value={from}
          onChange={e => setFrom(e.target.value)}
          style={{ marginLeft: 8 }}
        />
        <input
          type="date"
          value={to}
          onChange={e => setTo(e.target.value)}
          style={{ marginLeft: 8 }}
        />
        <button style={{ marginLeft: 8 }} onClick={fetchReport} disabled={loading}>
          {loading ? "Loading..." : "Get Report"}
        </button>
        {data && data.length > 0 && (
          <button
            style={{
              marginLeft: 8,
              background: "#224488",
              color: "#fff",
              border: "none",
              padding: "6px 16px",
              borderRadius: 4,
              cursor: "pointer",
            }}
            onClick={handleDownloadPDF}
          >
            Download PDF
          </button>
        )}
      </div>
      {error && <div style={{ color: "red" }}>{error}</div>}
      {data && data.length > 0 && (
        <table className="iem-table">
          <thead>
            <tr>
              <th>Sr No</th>
              <th>{type === "income" ? "Income Head" : "Expense Head"}</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{row.account_head}</td>
                <td>{Number(row.total).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
              </tr>
            ))}
            <tr>
              <th colSpan={2}>Total</th>
              <th>{totalAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</th>
            </tr>
          </tbody>
        </table>
      )}
      {data && !loading && data.length === 0 && <div>No data found.</div>}
    </div>
  );
}